import { styled } from '@mui/material/styles';

import { Screen } from '@/components/Layout/Screen';

import { getAssetPath } from '@/constants/configs';

export const Logo = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/logo-with-text.svg')} {...props} />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(6)} auto ${theme.spacing(8)}`,
  width: 206,
}));

export const FinishedLogo = styled(
  (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img
      src={getAssetPath('/logo-with-text.svg')}
      alt="Finished Logo"
      {...props}
    />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(24)} auto ${theme.spacing(10)}`,
  height: 'auto',
  width: 206,
}));

export const StyledFinishedScreen = styled(Screen)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: 'fixed',
  top: 0,
  left: 0,
}));

export const StyledCaymanValidationFailedScreen = styled(Screen)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
  }),
);

export const ThirdPartyComplianceCheckImage = styled(
  (
    props: React.ImgHTMLAttributes<HTMLImageElement> & {
      'data-test-id'?: string;
    },
  ) => (
    <img
      src={getAssetPath(
        '/assets/images/icon-third-party-compliance-screen.svg',
      )}
      alt="Third Party Compliance Check"
      loading="lazy"
      {...props}
    />
  ),
)();
